import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { IsAuthenticatedGuard } from './shared/services/guards/is-authenticated.guard';
import { TabAccessGuard } from './shared/services/guards/tab-access/tab-access.guard';
import { ACTIONS } from './common/constants/app.constants';
import { WhiteSourceLicenseComponent } from './components/white-source-license/white-source-license.component';

let INITIAL_REDIRECT = window.location.href.includes('/logout') ? '/logout' : '/projects';
export const routes: Routes = [
  {
    path: "",
    redirectTo: INITIAL_REDIRECT,
    pathMatch:  'full'
  },
  {
    path: "library",
    canActivate: [() => inject(IsAuthenticatedGuard).canActivate()],
    loadChildren: ()=> import('src/app/components/library/library.routes').then(c => c.LIBRARY_ROUTES)
  },
  {
    path: "projects",
    canActivate: [() => inject(IsAuthenticatedGuard).canActivate()],
    loadChildren: ()=> import('src/app/components/projects/projects.routes').then(r => r.PROJECTS_ROUTES)
  },
  {
    path: "platform-admin",
    canActivate: [() => inject(IsAuthenticatedGuard).canActivate(), () => inject(TabAccessGuard).canActivate(ACTIONS.platformAdmin)],
    loadChildren: ()=> import('src/app/components/platform-admin/platform-admin.routes').then(c => c.PLATFORM_ADMIN_ROUTES)
  },
  {
    path: "logout",
    loadComponent: ()=> import('src/app/components/logout/logout.component').then(c => c.LogoutComponent)
  },
  {
    path: "login-failed",
    loadComponent: ()=> import('src/app/components/login-failed/login-failed.component').then(c => c.LoginFailedComponent)
  },
  {
    path: "taxonomy",
    canActivate: [() => inject(IsAuthenticatedGuard).canActivate()],
    outlet: 'modal',
    loadChildren: ()=> import('src/app/components/library/components/taxonomy-modal/taxonomy-modal.routes').then(r => r.TAXONOMY_ROUTES)
  },
  {
    path: "unauthorized",
    loadComponent: () => import('src/app/components/unauthorized/unauthorized.component').then(c => c.UnauthorizedComponent)
  },
  { path: 'white-source-license', component: WhiteSourceLicenseComponent },
  {
    path: "**",
    loadComponent: () => import('src/app/components/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent)
  },
];

